import React, { useState } from "react";
import { api } from "../lib/api";
import { card, Btn, StatCard } from "./ui";
import { Sparkles, Loader2, TrendingUp, Users, Percent, CalendarCheck } from "lucide-react";

export default function AIForecast() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [prompt, setPrompt] = useState("Give me a forecast of upcoming workload, expected food volume and conversion trends.");

  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/ai-forecast", { prompt }); setData(data); }
    catch { setData({ insight: "Failed to generate. Try again.", summary: null }); }
    finally { setBusy(false); }
  };

  const md = (data?.insight || "").split("\n").map((line, i) => {
    if (line.startsWith("### ")) return <h4 key={i} className="font-serif text-lg text-gold mt-4 mb-1">{line.slice(4)}</h4>;
    if (line.startsWith("## ")) return <h3 key={i} className="font-serif text-xl text-gold mt-5 mb-2">{line.slice(3)}</h3>;
    if (line.startsWith("- ") || line.startsWith("* ")) return <li key={i} className="text-ivory/80 ml-5 list-disc">{line.slice(2)}</li>;
    if (!line.trim()) return <div key={i} className="h-2" />;
    return <p key={i} className="text-ivory/80">{line.replace(/\*\*/g, "")}</p>;
  });

  return (
    <div data-testid="admin-forecast" className="max-w-4xl">
      <p className="text-gold/70 text-xs tracking-[0.25em] uppercase">AI Forecast</p>
      <h1 className="font-serif text-4xl text-ivory mt-1 mb-2">Operational Insights</h1>
      <p className="text-ivory/50 text-sm mb-6">Estimates generated from live enquiry data. <span className="text-gold/70">All figures are predictions, not guarantees.</span></p>

      <div className={`${card} p-5 mb-6`}>
        <textarea value={prompt} onChange={(e) => setPrompt(e.target.value)} rows={2} className="w-full bg-[#1C1210] border border-gold/20 rounded-lg px-4 py-3 text-sm text-ivory mb-3" />
        <Btn onClick={run} disabled={busy} data-testid="run-forecast">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} Generate Forecast</Btn>
      </div>

      {data?.summary && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          <StatCard label="Total Enquiries" value={data.summary.total_enquiries} icon={TrendingUp} />
          <StatCard label="Confirmed" value={data.summary.confirmed_events} icon={CalendarCheck} />
          <StatCard label="Conversion" value={`${data.summary.conversion_rate}%`} icon={Percent} />
          <StatCard label="Est. Guests" value={data.summary.total_expected_guests} icon={Users} />
        </div>
      )}

      {data && (
        <div className={`${card} p-6`}>
          <div className="flex items-center gap-2 mb-4"><Sparkles className="w-5 h-5 text-gold" /><h3 className="font-serif text-xl text-gold">AI Analysis</h3></div>
          <div className="space-y-1">{md}</div>
        </div>
      )}
    </div>
  );
}
